import React from 'react';

import { CheckmarkFill, CircleOutline, CloseOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';

import { OptionsListItemTypeEnum } from '../../../single-select/types';

const iconStyles = 'w-[10.67px] h-[10.67px]';

interface ReviewIconProps {
  className?: string;
  type: OptionsListItemTypeEnum;
  keyCode?: string;
}

const ReviewIcon: React.FC<ReviewIconProps> = ({ className, type, keyCode }) => {
  switch (type) {
    case OptionsListItemTypeEnum.Correct: {
      return (
        <Stack
          alignItems="center"
          className={cn('h-16 w-16 rounded bg-[--green-200] mt-[0.3rem] flex-shrink-0', className)}
          justifyContent="center">
          <CheckmarkFill className={iconStyles} />
        </Stack>
      );
    }
    case OptionsListItemTypeEnum.Incorrect: {
      return (
        <Stack
          alignItems="center"
          className={cn('h-16 w-16 rounded bg-[--red-200] mt-[0.3rem] flex-shrink-0', className)}
          justifyContent="center">
          <CloseOutline className={iconStyles} />
        </Stack>
      );
    }
    case OptionsListItemTypeEnum.Missed: {
      return (
        <CircleOutline
          className={cn('h-16 w-16 mt-[0.3rem] flex-shrink-0', className)}
          fillColorToken="icon-success"
        />
      );
    }
    case OptionsListItemTypeEnum.PartiallyCorrectMissed: {
      return (
        <CircleOutline
          className={cn('h-16 w-16 mt-[0.3rem] flex-shrink-0', className)}
          fillColorToken="icon-warning"
        />
      );
    }
    case OptionsListItemTypeEnum.PartiallyCorrect: {
      return (
        <Stack
          alignItems="center"
          className={cn('h-16 w-16 rounded bg-[--yellow-200] mt-[0.3rem] flex-shrink-0', className)}
          justifyContent="center">
          <CheckmarkFill className={iconStyles} />
        </Stack>
      );
    }
    case OptionsListItemTypeEnum.Selected: {
      if (keyCode) {
        return (
          <Stack
            alignItems="center"
            className={cn(
              'h-16 w-16 rounded-[0.3rem] bg-[--black] mt-[0.3rem] flex-shrink-0',
              className,
            )}
            justifyContent="center">
            <Typography color="text-text-white" variant="label-03">
              {keyCode}
            </Typography>
          </Stack>
        );
      }
      break;
    }
  }

  return null;
};

export default ReviewIcon;
